import React from "react";
import { motion } from "framer-motion";
import "./GradientBlueCard.scss";

interface Props {
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  effect?: boolean;
}

export const GradientBlueCard = ({
  className,
  children,
  style = {},
  effect = false,
}: Props) => {
  return (
    <motion.div
      initial={
        effect
          ? {
              filter: "blur(2px)",
            }
          : {}
      }
      whileInView={
        effect
          ? {
              filter: "blur(0px)",
            }
          : {}
      }
      transition={
        effect
          ? {
              duration: 0.5,
              ease: "easeInOut",
              delay: 0.25,
            }
          : {}
      }
      style={style}
      className={`${className} gradient-blue-card`}
    >
      {children}
    </motion.div>
  );
};
